import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const generateSortingLicensePlate = {
  name: "generateSortingLicensePlate" as const,
  input: z.object({
    returnId: z.string().min(1),
    locationId: locationIdFormat.schema,
    merchantName: z.string().min(1).optional(),
    orderNumber: z.string().min(1).optional(),
    itemCount: z.number().int().positive().optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
  }),
  output: z.object({ pdfBase64: z.string(), printed: z.boolean().optional() }),
};
